import { CreateCertificateDto, DecennialCertificateColumns } from "@dune/types";
import { getErrorMessage } from "@dune/vars";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { privateAxios } from "../axios";
import { contractorsQueryKeys } from "../query-keys/contractors.query-keys";

export const uploadContractorCertificate = async (
	data: CreateCertificateDto,
): Promise<DecennialCertificateColumns> => {
	const { contractorId, ...certificateData } = data;
	const response = await privateAxios.post<DecennialCertificateColumns>(
		`/contractors/${contractorId}/certificates`,
		certificateData,
	);
	return response.data;
};

export const useUploadContractorCertificateMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: uploadContractorCertificate,
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({
				queryKey: contractorsQueryKeys.contractorById(variables.contractorId),
			});

			queryClient.invalidateQueries({
				queryKey: contractorsQueryKeys.detail(
					variables.contractorId.toString(),
				),
			});

			queryClient.invalidateQueries({
				queryKey: contractorsQueryKeys.details(),
			});

			toast.success("Attestation ajoutée avec succès");
		},
		onError: (error) => {
			const errorMessage = getErrorMessage(error);
			toast.error("Erreur lors de l'ajout de l'attestation", {
				description: errorMessage,
			});
		},
	});
};
